var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32197 8.62834L11.2667 1.35159C11.5898 0.962668 12.1707 0.887304 12.5881 1.17114C13.0417 1.4789 13.1392 2.09663 12.7876 2.52074L6.13867 10.6478C5.95961 10.8638 5.69261 10.9908 5.4323 10.9982C5.39338 11.0001 5.39338 11.0001 5.37836 11C5.10968 11 4.85069 10.8934 4.66583 10.7012L1.26081 7.17549C0.877607 6.77966 0.923481 6.15531 1.35364 5.8143C1.7496 5.49953 2.33499 5.53535 2.68595 5.89888L5.32197 8.62834Z",
    fill: "#1B8C96"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 12,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.32197 8.62834L11.2667 1.35159C11.5898 0.962668 12.1707 0.887304 12.5881 1.17114C13.0417 1.4789 13.1392 2.09663 12.7876 2.52074L6.13867 10.6478C5.95961 10.8638 5.69261 10.9908 5.4323 10.9982C5.39338 11.0001 5.39338 11.0001 5.37836 11C5.10968 11 4.85069 10.8934 4.66583 10.7012L1.26081 7.17549C0.877607 6.77966 0.923481 6.15531 1.35364 5.8143C1.7496 5.49953 2.33499 5.53535 2.68595 5.89888L5.32197 8.62834Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/green-checkmark.d3178936b08520e0c6489c11725ad509.svg";
export { ForwardRef as ReactComponent };